import enabled from './helpers/enabled'
import sumNames from './helpers/sumNames'

export default (form) => (
  sumNames(enabled(form, 'income'), ['monthlyPay', 'monthlyOther']) +
  sumNames(enabled(form, 'income'), ['annualOther']) / 12
)
